import Home from 'views/Home';
import Page from 'views/Page';
import NotFound from 'views/NotFound';
import Employees from 'views/Employees';
import News from 'views/News';
import Tours from 'views/Tours';
import SingleNews from 'views/SingleNews';
import Projects from 'views/Projects';
import SingleProject from 'views/SingleProject';
import SingleTour from 'views/SingleTour';

export default [

    { path: '/cms', exact: true, component: () => window.location.replace('/cms/wp-login.php') },
    { path: '/en/cms', exact: true, component: () => window.location.replace('/cms/wp-login.php') },

    { path: '/404', exact: true, component: NotFound },
    { path: '/en/404', exact: true, component: NotFound },

    { path: '/', exact: true, component: Home },
    { path: '/en', exact: true, component: Home },

    { path: '/folk', exact: true, component: Employees },
    { path: '/en/people', exact: true, component: Employees },

    { path: '/nyheter', exact: true, component: News },
    { path: '/en/news', exact: true, component: News },

    { path: '/studieturer', exact: true, component: Tours },
    { path: '/en/tours', exact: true, component: Tours },

    { path: '/prosjekter', exact: true, component: Projects },
    { path: '/en/projects', exact: true, component: Projects },

    { path: '/nyheter/:slug', exact: true, component: SingleNews },
    { path: '/en/news/:slug', exact: true, component: SingleNews },

    { path: '/studieturer/:slug', exact: true, component: SingleTour },
    { path: '/en/tours/:slug', exact: true, component: SingleTour },

    { path: '/prosjekter/:slug', exact: true, component: SingleProject },
    { path: '/en/projects/:slug', exact: true, component: SingleProject },
    
    { path: '/:slug', exact: true, component: Page },
    { path: '/:parent/:slug', exact: true, component: Page },
    { path: '/en/:slug', exact: true, component: Page },
    { path: '/en/:parent/:slug', exact: true, component: Page },

]


// WEBPACK FOOTER //
// ./src/routes.js